import React, { useState } from 'react';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import LoadSimple from '../../LoadSimple';

const ModalCreateTicketNew = ({ props, closeTicket }) => {
  const [addingException, setAddingException] = useState(false);
  const [msgError, setMsgError] = useState({ status: false, text: '' });
  const [statusTypeTicket, setStatusTypeTicket] = useState(1);
  const [valTypeTicket, setValTypeTicket] = useState('internal_note');

  const [ManttoData, setManttoData] = useState({
    host_id: props.data.hostid,
    event_id: props.data.eventid,
    comment: ""
  });

  const changeTypeTicket = (type) => {
    setStatusTypeTicket(type);
    if (type === 1) {
      setValTypeTicket('internal_note');
    } else {
      setValTypeTicket('progress_solution');
    }
  };

  const handleTextAreaChange = (event) => {
    setManttoData(prev => ({ ...prev, comment: event.target.value }));
  };

  const addTicket = async () => {
    setAddingException(true);
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/demo-tickets', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(ManttoData)
      });

      if (response.ok) {
        await trigger_ticket();
        setAddingException(false);
        setMsgError({ status: false, text: '' });
        props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])), '', true);
        closeTicket();
      } else {
        const data = await response.json();
        props.handleShowPopup('ERROR!!!!', capitalizeFirstLetter((lang[props.languaje]['regNoGenCorr'])), data.detail, false);
        setMsgError({ status: true, text: data.detail });
        setAddingException(false);
      }
    } catch (error) {
      setAddingException(false);
    }
  };

  const addCommentTicket = async () => {
    setAddingException(true);
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/gs/tickets/comment/', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify({
          ticket_id: props.data.ticket_id,
          comment: ManttoData.comment,
          comment_type: valTypeTicket
        })
      });
      if (response.ok) {
        setAddingException(false);
        closeTicket();
        setValTypeTicket('internal_note');
      } else {
        setAddingException(false);
      }
    } catch (error) {
      setAddingException(false);
    }
  };

  const trigger_ticket = async () => {
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/surveys/trigger_ticket_creation', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data.data.survey_id != null) {
          props.setImportModalOpen(true);
          props.setSuveryId(data.data.survey_id);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const isNewTicket = (props.data.ticket_id == null || props.data.ticket_id === "");

  return (
    <div style={{
      background: 'rgba(15, 30, 56, 0.55)',
      backdropFilter: 'blur(2px)',
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        width: '100%', maxWidth: 440,
        boxShadow: '0 20px 60px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.05)',
        overflow: 'hidden',
        animation: 'slideUp 0.2s ease',
        height: '100%'
      }}>
        <style>
          {`
            @keyframes slideUp {
              from { opacity: 0; transform: translateY(12px) }
              to   { opacity: 1; transform: translateY(0) }
            }
          `}
        </style>

        {/* HEADER */}
        <div style={{ background: '#0f2d5e', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: 'rgba(255,255,255,.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                <line x1="7" y1="7" x2="7.01" y2="7"></line>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>
                {isNewTicket ? 'Crear Ticket' : 'Agregar Comentario'}
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,.5)', marginTop: 1 }}>
                {isNewTicket ? 'Abrir ticket de soporte' : 'Actualizar ticket existente'}
              </div>
            </div>
          </div>
          <button style={{
            width: 26, height: 26, borderRadius: 6,
            border: '0.5px solid rgba(255,255,255,.15)',
            background: 'rgba(255,255,255,.08)',
            cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            color: 'rgba(255,255,255,.6)'
          }} onClick={closeTicket}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* INFO BAR */}
        <div style={{ background: '#f1f5f9', borderBottom: '1px solid #e2e8f0', padding: '10px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
          {isNewTicket ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Host ID</span>
                <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500, color: '#1a56db', background: '#e8f0fe', border: '1px solid #c3dafe', borderRadius: 5, padding: '2px 8px' }}>
                  {props.data.hostid}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Event ID</span>
                <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500, color: '#1a56db', background: '#e8f0fe', border: '1px solid #c3dafe', borderRadius: 5, padding: '2px 8px' }}>
                  {props.data.eventid}
                </span>
              </div>
            </>
          ) : (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>FOLIO</span>
                <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500, color: '#057a55', background: '#def7ec', border: '1px solid #bcf0da', borderRadius: 5, padding: '2px 8px' }}>
                  {props.data.ticket_id}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
                <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Status</span>
                <span style={{
                  fontSize: 10, fontWeight: 500,
                  color: props.data.ticket_status === 'creado' ? '#057a55' : props.data.ticket_status === 'error' ? '#e02424' : '#d97706',
                  textTransform: 'capitalize'
                }}>
                  {props.data.ticket_status}
                </span>
              </div>
            </>
          )}
        </div>

        {/* BODY */}
        <div style={{ padding: '18px 18px 14px' }}>

          {!isNewTicket && props.data.ticket_status === 'creado' && (
            <div style={{
              display: 'flex', gap: 10, marginBottom: 16,
              padding: '4px', background: '#f1f5f9', borderRadius: 9,
              border: '1px solid #e2e8f0'
            }}>
              <div
                onClick={() => changeTypeTicket(1)}
                style={{
                  flex: 1, cursor: 'pointer', padding: '8px', borderRadius: 6,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  background: statusTypeTicket === 1 ? '#fff' : 'transparent',
                  boxShadow: statusTypeTicket === 1 ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                  border: statusTypeTicket === 1 ? '1px solid #e2e8f0' : '1px solid transparent',
                  transition: 'all .2s'
                }}
              >
                <div style={{
                  width: 14, height: 14, borderRadius: '50%',
                  border: statusTypeTicket === 1 ? '4px solid #1a56db' : '1px solid #cbd5e1',
                  background: '#fff'
                }} />
                <span style={{ fontSize: 11, fontWeight: 500, color: statusTypeTicket === 1 ? '#0f172a' : '#64748b' }}>Nota interna</span>
              </div>
              <div
                onClick={() => changeTypeTicket(2)}
                style={{
                  flex: 1, cursor: 'pointer', padding: '8px', borderRadius: 6,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  background: statusTypeTicket === 2 ? '#fff' : 'transparent',
                  boxShadow: statusTypeTicket === 2 ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                  border: statusTypeTicket === 2 ? '1px solid #e2e8f0' : '1px solid transparent',
                  transition: 'all .2s'
                }}
              >
                <div style={{
                  width: 14, height: 14, borderRadius: '50%',
                  border: statusTypeTicket === 2 ? '4px solid #1a56db' : '1px solid #cbd5e1',
                  background: '#fff'
                }} />
                <span style={{ fontSize: 11, fontWeight: 500, color: statusTypeTicket === 2 ? '#0f172a' : '#64748b' }}>Avance y solución</span>
              </div>
            </div>
          )}

          {isNewTicket || props.data.ticket_status === 'creado' ? (
            <>
              <label style={{ fontSize: 10, fontWeight: 600, color: '#334155', textTransform: 'uppercase', letterSpacing: '.07em', display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}>
                Notas
              </label>
              <textarea
                name="comment"
                placeholder="Escribe aquí los detalles..."
                value={ManttoData.comment}
                onChange={handleTextAreaChange}
                style={{ width: '90%', border: '1px solid #e2e8f0', borderRadius: 7, color: '#334155', fontSize: 11, padding: '10px 12px', background: '#fff', outline: 'none', resize: 'none', height: 120, lineHeight: 1.5, transition: 'all .15s', marginBottom: 16 }}
                onFocus={e => { e.target.style.borderColor = '#1a56db'; e.target.style.boxShadow = '0 0 0 3px #e8f0fe'; }}
                onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
              />
            </>
          ) : (
            <div style={{
              textAlign: 'center', padding: '20px 0',
              color: props.data.ticket_status === "solicitado" ? '#334155' : '#e02424',
              fontSize: 12, lineHeight: 1.6
            }}>
              {props.data.ticket_status === "solicitado"
                ? 'Se ha solicitado un ticket. Por favor, espera a que sea aceptado.'
                : `Error al solicitar el ticket: ${props.data.ticket_error}`}
            </div>
          )}

          {msgError.status && (
            <div style={{ color: '#e02424', fontSize: 11, textAlign: 'center', marginBottom: 12 }}>
              {msgError.text}
            </div>
          )}

          <div style={{ height: 1, background: '#e2e8f0', margin: '0 -18px 14px' }} />

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', color: '#334155', fontSize: 12, fontWeight: 500, padding: '9px 20px', cursor: 'pointer' }}
              onClick={closeTicket}
            >
              Cancelar
            </button>
            {(isNewTicket || props.data.ticket_status === 'creado') && (
              <button
                disabled={addingException}
                style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, borderRadius: 7, border: 'none', background: '#1a56db', color: '#fff', fontSize: 12, fontWeight: 500, padding: '9px 20px', cursor: addingException ? 'not-allowed' : 'pointer', opacity: addingException ? 0.7 : 1 }}
                onClick={isNewTicket ? addTicket : addCommentTicket}
              >
                {addingException ? <LoadSimple /> : (isNewTicket ? 'Guardar' : 'Agregar')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCreateTicketNew;
